import React from 'react'

const GlobeIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="globeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 180, 255, 1)" />
          <stop offset="100%" stopColor="rgba(60, 140, 220, 1)" />
        </linearGradient>
        <filter id="globeGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Globe circle */}
      <circle 
        cx="12" 
        cy="12" 
        r="9"
        stroke="url(#globeGradient)"
        strokeWidth="2"
        fill="none"
        filter="url(#globeGlow)"
      />
      
      {/* Vertical line */}
      <ellipse 
        cx="12" 
        cy="12" 
        rx="4" 
        ry="9"
        stroke="url(#globeGradient)"
        strokeWidth="1.5"
        fill="none"
      />
      
      {/* Horizontal lines */}
      <line 
        x1="3" 
        y1="12" 
        x2="21" 
        y2="12" 
        stroke="url(#globeGradient)"
        strokeWidth="1.5"
      />
      <ellipse 
        cx="12" 
        cy="12" 
        rx="9" 
        ry="4"
        stroke="url(#globeGradient)"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  )
}

export default GlobeIcon
